import { useEffect, useState } from "react";
import { fetchData, GET_ALL_CATEGORIES } from "../../components/Service";
import { Link } from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";

const Classified = () => {
	const [list, setList] = useState([]);

	const getFreeAdsCatList = () => {
		fetchData(GET_ALL_CATEGORIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setList(res.data);
			} else {
				setList([]);
			}
		});
	};

	useEffect(() => {
		scrollTop();
		getFreeAdsCatList();
	}, []);

	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 class="text-white d-flex mb-0 py-2">Classifieds</h4>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1 body-minh">
					<div className="row">
						{list &&
							list.length > 0 &&
							list?.map((item) => (
								<div key={item.id} className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 event_n mb-1">
									<div className="card-grid-2 hover-up h-100 mb-0">
										<div className="card-block-info position-relative">
											<div className="card-2-bottom">
												<div className="row d-flex align-items-center">
													<div className="col-12">
														{item.id == 5 ? (
															<Link to={`/real-estate`} state={{ pageTitle: item.name }} className="btn btn-classified text-white w-100">
																{item.name}
															</Link>
														) : item.id == 1 ? (
															<Link to={`/autos`} state={{ pageTitle: item.name }} className="btn btn-classified text-white w-100">
																{item.name}
															</Link>
														) : (
															<Link to={`/classifieds/${item.id}`} state={{ pageTitle: item.name }} className="btn btn-classified text-white w-100">
																{item.name}
															</Link>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Classified;
